import React from "react";

const Clip = ({ height = "10px", style }) => (
  <svg
    height={height}
    style={style}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.9557 11.0476L8.77689 13.2264C7.56842 14.4348 7.56842 16.3843 8.77689 17.5927C9.98537 18.8012 11.9348 18.8012 13.1433 17.5927L16.5746 14.1614C18.9827 11.7533 18.9827 7.83677 16.5746 5.42865C14.1665 3.02053 10.25 3.02053 7.84187 5.42865L4.10179 9.16873C2.03769 11.2328 2.03769 14.5848 4.10179 16.6577"
      stroke="#9E8C2F"
      strokeWidth="1.69362"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default Clip;
